module.exports = __webpack_public_path__ + "static/media/landing-top-person.44c92f6f.png";